import CryptoJS from "crypto-js";


const SECRET_KEY = "vfdfhjgfdfsrfjkjhjgfdrsadxfcgjkuytfhdtzsrfxgchgjkhgsfzxgcxhjgkyhghfgdfstjdghfxdftgdht"; // Must match server key

function encryptData(data) {
    return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
}

const username = process.env.REACT_APP_USERNAME;
const password = process.env.REACT_APP_PASSWORD;

export const encryptedAuth = encryptData({ username, password });